const faqs = [
    {

      question: 'Czego potrzebuję aby zacząć?',
      answer:
        'Do wypożyczania niezbędne będzie konto, które możesz założyć za darmo. Ponadto do prowadzenia własnej biblioteki będą niezbędne karty do katalogowania.',
    },
    {

      question: 'Czym są karty do katalogowania?',
      answer:
        'To wydrukowane kartki z nazwą twojej biblioteki i unikalnym kodem QR dla każdej książki.',
    },
    {

      question:
        'Czy katalogowanie wiąże się z jakimiś opłatami?',
      answer:
        "Nie. Katalogowanie książek jest darmowe. Wymagane są jedynie kody, które można wygenerować po zarejestrowaniu.",
    },
    {

      question: 'Jakie książki mogę katalogować?',
      answer:
        'Książki, które posiadając numer ISBN 10 lub 13 cyfrowy (wydane po 1982 roku).',
    },

  ];

  export default faqs